import script from "./loginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./loginPage.vue?vue&type=script&setup=true&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=4bc127f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc127f2"]])

export default __exports__